
import React, { Component } from 'react';
import { connect } from 'dva';
import { modelUtils } from '@/utils';
import { utils_tool, component_tool, framework_tool } from '@/tool';
let { Session } = utils_tool;
import { WizTableForm, WizDataAuthSelect } from '@/containers/common'
import  ProgramAuthSelect  from './programAuthSelect'
let { WizButton, WizCard, WizAntdForm, WizCustomSteps, WizRow, WizCol } = component_tool
let { WizContainer } = framework_tool
import { Form, Spin } from 'antd'
const getParamRecord = (history,pathname) => {
    let record = 0
    if (history.location) {
        if (history.location.pathname === pathname+'/programAuth') {
            if (history.location && history.location.record) {
                record = history.location.record['id']
                Session.set('programChapterId', record)
            } else {
                record = Session.get('programChapterId') || 0
            }
        }
    } else {
        record = Session.get('programChapterId') || 0
    }
    return record
}
class ProgramAuth extends WizContainer {
    componentName = 'ProgramAuth';

    constructor(props) {
        super(props);
        let pathname = '/program/programList'
        if (history.location.pathname.startsWith('/perm/programPerm/programList')) {
          pathname = '/perm/programPerm/programList'
        }
        this.pathname = pathname
        let id = getParamRecord(props.history, pathname)
        this.state = {
            id,
            initialValue: {
                orgIds:[],
                positionIds:[],
                positionCategoryIds:[],
                personIds:[]
            }
        }
    }

    //START propsAndStateOnChange
    propsAndStateOnChange = {
        authInfo: this._authInfo.bind(this),
        saveAuthKey: this._saveAuthKey.bind(this),
    };

    _saveAuthKey(nextProps, nextState) {
        let { saveAuthKey } = nextProps
        let { id } = nextState
        if (saveAuthKey && (saveAuthKey['success'] || saveAuthKey['code'] == 1 )) {
            let authUpd = saveAuthKey["data"]
            if(authUpd){
                if(authUpd>0){
                    
                WizModal.confirm({
                  title: '注意', content:"消息通知内容有变更，是否重新发送消息通知",cancelText:"否",okText:"是",
                  onOk: () => {
                    this.doActions([
                      {
                        path:  "notice/sendNotice",
                        payload: {
                          key: "sendNoticeKey",
                          apiParams: {
                            bizId: id,
                            bizType: 0,
                            resend:true
                          },
                        },
                      },
                    ]);

                    this.jumpPage('replace', this.pathname);
                  },
                  onCancel: () => {
                    this.doActions([
                      {
                        path:  "notice/sendNotice",
                        payload: {
                          key: "sendNoticeKey",
                          apiParams: {
                            bizId: id,
                            bizType: 0,
                            resend:false
                          },
                        },
                      },
                    ]);

                    this.jumpPage('replace', this.pathname);
                  }
                });
                
            }else{
                this.doActions([
                    {
                      path:  "notice/sendNotice",
                      payload: {
                        key: "sendNoticeKey",
                        apiParams: {
                          bizId: id,
                          bizType: 0,
                          resend:false
                        },
                      },
                    },
                  ]);

                  this.jumpPage('replace', this.pathname);
            }
              }else{

                this.jumpPage('replace', this.pathname);
              }
            wizNotice.success(saveAuthKey['msg'])
            return true
        } else {
            wizNotice.error(saveAuthKey && saveAuthKey['msg'] || '操作失败,请稍后尝试')
            return false
        }
    }

    _authInfo(nextProps, nextState) {
        let { authInfo } = nextProps
        if (authInfo && authInfo['success']) {
            this.setState({
                initialValue: authInfo['data'],
            });
        } 
        return false
    }

    _componentDidMount() {
        this.doActions([
            {
                path: 'program/authInfo',
                payload: {
                    key: 'programAuthInfo',
                    apiParams: {
                        id: this.state.id
                    }
                }
            },
        ]);
        const arr = [];
        this.setState({
            data: arr
        });
    }
   
    stepView = () => {
        const { initialValue } = this.state
        const selectProps = {
            title: '受众设置',
            id: this.state.id,
            initialValue: initialValue,
            submit: (value) => {
                let saveRequest = {}
                // if (value['dataAuth']) {
                //     let dataAuth = value['dataAuth']
                //     saveRequest.isAll = dataAuth.isAll
                //     saveRequest['orgIds'] = dataAuth['orgIds'].map(p => (p.id))
                //     saveRequest['positionIds'] = dataAuth['positionIds'].map(p => (p.id))
                //     saveRequest['positionCategoryIds'] = dataAuth['positionCategoryIds'].map(p => (p.id))
                //     saveRequest['personIds'] = dataAuth['personIds'].map(p => (p['id']))
                // }
                if (value['dataAuth']) {
                    if(value['dataAuth'].groupId && value['dataAuth'].groupId.length) {
                      saveRequest['groupId'] = dataAuth['groupId'].map(p => (p.id)).toString();
                    }else{
                      saveRequest['orgIds'] = dataAuth['orgIds'] && dataAuth['orgIds'].map(p => (p.id))
                      saveRequest['positionIds'] = dataAuth['positionIds'] && dataAuth['positionIds'].map(p => (p.id))
                      saveRequest['positionCategoryIds'] = dataAuth['positionCategoryIds'] && dataAuth['positionCategoryIds'].map(p => (p.id))
                      saveRequest['personIds'] = dataAuth['personIds'] && dataAuth['personIds'].map(p => (p['id']))
                    }
                  }
                saveRequest['id'] = this.state.id
                this.doAction({
                    path: 'program/saveAuth',
                    payload: {
                        key: "programSaveAuthKey",
                        apiParams: {
                            ...saveRequest
                        }
                    }
                });
            },
        };


        return <ProgramAuthSelect {...selectProps} />

    }
    /**
       * 重置表单
       */
    handleReset = () => {
        //重置表单
        this.props.form.resetFields();
    };

    _render() {
        let { programLoading } = this.props
        let wizCustomStepsProps = {
            header: [
                { title: '课程信息' },
                { title: '课程内容' },
                { title: '受众设置' }
            ],
            current: 2,
            content: this.stepView(),
            footer: null
        }
        return <Spin tip={'加载中'} spinning={programLoading}>
            <WizCustomSteps {...wizCustomStepsProps} />
        </Spin>

    }

}

const mapStateToProps = (state, ownProps) => {

    const { program } = state;
    const authInfo = modelUtils.getModelEntity(program, "programAuthInfo");
    const saveAuthKey = modelUtils.getModelEntity(program, "programSaveAuthKey");

    const load = modelUtils.getLoadingState(state, ['program']);
    return {
        authInfo,
        saveAuthKey,
        ...load
    }
};

export default connect(mapStateToProps)(ProgramAuth)